import React from 'react';
import clsx from 'clsx';
import closeIcon from '../close.svg';
import styles from '../BottomDrawer.module.scss';

interface BottomDrawerHeaderProps {
    children?: React.ReactNode;
    width?: string;
    onClose?: () => void;
    /** Optional controls between the heading text and the close icon — own flex item, sized to
     * its own content, never squeezed by the heading's ellipsis box. */
    actions?: React.ReactNode;
}
function BottomDrawerHeader({ children, width, onClose, actions }: BottomDrawerHeaderProps) {
    return (
        <div className={clsx(styles.DrawerHeader, { [styles.DrawerHeaderWithActions]: !!actions })}>
            <div className={styles.DrawerHeaderText} style={width ? { width } : {}}>
                {children}
            </div>
            {actions && <div className={styles.DrawerHeaderActions}>{actions}</div>}
            {onClose && (
                <img className={styles.DrawerHeaderClose} src={closeIcon} alt="close" style={{ height: '0.9375rem' }} onClick={onClose} />
            )}
        </div>
    );
}

export default BottomDrawerHeader;
